import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class ScrollText {
    constructor(el) {
        this.scrollWrapper = el;

        this.texts = this.scrollWrapper.querySelectorAll('[data-scroll-index]');
        this.texts.forEach((text, index) => {
            ScrollTrigger.create({
                trigger: text,
                start: 'top center',
                onToggle: (self) => {
                    if (self.isActive) {
                        this.scrollWrapper.querySelectorAll('[data-scroll]').forEach((el) => {
                            el.classList.remove('active');
                        });
                        this.scrollWrapper.querySelector(`[data-scroll="${index}"]`).classList.add('active');
                    }
                },
            });
        });

        this.init();
    }

    init() {
        this.scrollWrapper.querySelector('[data-scroll="0"]').classList.add('active');
    }
}